import {Sequence} from 'components/Sequence';
import {StrandOfDoubleStranded} from 'constants/MolbioConstants';
import {DEFAULT_TYPE} from 'molbio/maps/PrimersViewConstants';
import Type from 'molbio/maps/Type';
import SequencePrimer from 'molbio/primers/backbone/SequencePrimer';
import {getModificationsForPrimerDisplay} from 'molbio/primers/PrimerUtil';
import * as sequtil from 'molbio/SeqUtil';
import * as vo from 'settings/visibility-options/VisibilityOptions';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';

function _shouldDrawPrimer(
  primer: SequencePrimer,
  sequence: Sequence,
  sliceStart: number,
  sliceEnd: number,
  primerBasesVisible: boolean,
  strand?: StrandOfDoubleStranded
): boolean {
  const primerStart = primerBasesVisible ? primer.drawStart(sequence) : primer.start();
  const primerEnd = primerBasesVisible ? primer.drawEnd(sequence) : primer.end();
  return (
    sequtil.isRangeOverlap(primerStart, primerEnd, sliceStart, sliceEnd) &&
    (strand == null || primer.strand() === strand)
  );
}

export function getSlicePrimers(
  sequence: Sequence,
  sliceStart: number,
  sliceEnd: number,
  primerBasesVisible: boolean,
  strand?: StrandOfDoubleStranded
): Array<SequencePrimer> {
  return sequence
    .sequencePrimers()
    .filter((primer) =>
      _shouldDrawPrimer(primer, sequence, sliceStart, sliceEnd, primerBasesVisible, strand)
    );
}

export function getSliceHasAnyPrimerMods(
  sequence: Sequence,
  sliceStart: number,
  sliceEnd: number,
  primerBasesVisible: boolean
): boolean {
  return getSlicePrimers(sequence, sliceStart, sliceEnd, primerBasesVisible).some(
    (primer: SequencePrimer) =>
      getModificationsForPrimerDisplay(primer.modifiedNucleotides(), primer.nucleotideType()).length > 0
  );
}

export function getPrimerBasesVisible(visibilityOptions: VisibilityOptions): boolean {
  return visibilityOptions.getOption(vo.PRIMER_BASES.name)?.get('visible') ?? false;
}

export function getPrimerType(visibilityOptions: VisibilityOptions, residuesType: Type): Type {
  return getPrimerBasesVisible(visibilityOptions) ? residuesType : DEFAULT_TYPE;
}
